<div class="mt-3">
  <label class="block text-xs font-medium text-gray-700 mb-1">
    <span i18n="Price change reason label">Razlog spremembe cene</span>
    <span class="text-red-500">*</span>
  </label>
  <select
    [formControl]="formGroup.controls['priceChangeReason']"
    [disabled]="disabled"
    (change)="onReasonChange()"
    class="w-full px-3 py-2 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
    [class.border-gray-300]="!formGroup.controls['priceChangeReason'].invalid || !formGroup.controls['priceChangeReason'].touched"
    [class.border-red-500]="formGroup.controls['priceChangeReason'].invalid && formGroup.controls['priceChangeReason'].touched">
    <option value="" disabled i18n="Price change reason placeholder">Izberite razlog...</option>
    @for (entry of choiceEntries; track entry[0]) {
      <option [value]="entry[0]">{{ entry[1] }}</option>
    }
  </select>
  @if (formGroup.controls['priceChangeReason'].invalid && formGroup.controls['priceChangeReason'].touched) {
    <p class="mt-1 text-xs text-red-500" i18n="Price change reason required error">
      Razlog spremembe cene je obvezen.
    </p>
  }

  @if (isOtherSelected) {
    <div class="mt-2">
      <textarea
        [formControl]="formGroup.controls['priceChangeDescription']"
        [disabled]="disabled"
        class="w-full px-3 py-2 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
        [class.border-gray-300]="!formGroup.controls['priceChangeDescription'].invalid || !formGroup.controls['priceChangeDescription'].touched"
        [class.border-red-500]="formGroup.controls['priceChangeDescription'].invalid && formGroup.controls['priceChangeDescription'].touched"
        rows="2"
        placeholder="Vpišite razlog..."
        i18n-placeholder="Price change custom reason placeholder"
      ></textarea>
      @if (formGroup.controls['priceChangeDescription'].invalid && formGroup.controls['priceChangeDescription'].touched) {
        <p class="mt-1 text-xs text-red-500" i18n="Price change description required error">
          Opis spremembe cene je obvezen.
        </p>
      }
    </div>
  }
</div>
